import { PDP_SLIDER_SIZES } from "@/constants/index"
import { SCENE7_SERVER_IMAGE } from "@/components/ImageGallery/v2/constants"

export const openModal = () => {}
let count = 0
export const openModalAction = (image, isVideo = "") => {
  if (!isVideo) {
    pauseAllVideo()
  }

  const s7viewerSpinThreeSixty = document.querySelector(
    "#s7viewerSpinThreeSixty"
  )
  if (s7viewerSpinThreeSixty) {
    document.getElementById("s7viewerSpinThreeSixty").innerHTML = ""
    document.getElementById("s7viewerSpinThreeSixty").style.display = "none"
  }
  document.body.classList.add("zoom-image-scroll")
  count++
  const element = document.querySelector(".product-detail-page")
  element?.classList.add("zoom-image-product-section")
  element?.classList.remove("three-sixty-image-gallery")
  document.getElementById("imageoverlay").style.display = "block"
  if (count >= 3) {
    const elementImage = document.querySelector("#imageoverlay")
    elementImage?.classList.add("zoom-activated")
  }

  document.body.classList.add("zoom-image-scroll")
  initZoomviewer(image, isVideo)
}
export const initZoomviewer = (assetID, isVideo = "") => {
  const s7viewerSpinThreeSixty = document.querySelector(
    "#s7viewerSpinThreeSixty"
  )
  if (s7viewerSpinThreeSixty) {
    document.getElementById("s7viewerSpinThreeSixty").innerHTML = ""
    document.getElementById("s7viewerSpinThreeSixty").style.display = "none"
  }
  const element = document.querySelector(".product-detail-page")
  element?.classList.remove("three-sixty-image-gallery")
  count++
  const zoomViewer = new window.s7viewers.ZoomViewer()
  zoomViewer?.setContainerId("s7viewer")
  zoomViewer?.setParam("serverurl", SCENE7_SERVER_IMAGE)
  zoomViewer?.setAsset(`PAWEB/${assetID}`)
  zoomViewer?.init()
  const zoomVideo = document.querySelector(".zoom-video")
  if (zoomVideo) {
    document.getElementById("zoomVideo").style.display = "none"
  }
  if (isVideo) {
    document.getElementById("s7viewer").style.display = "none"
    document.getElementById("s7viewerSpinThreeSixty").style.display = "none"
    const zoomPopupVideo = document.querySelector("#zoomVideo")
    if (zoomPopupVideo) {
      document.getElementById("zoomVideo").style.display = "block"
    }
  } else {
    if (zoomVideo) {
      document.getElementById("zoomVideo").style.display = "none"
    }
    document.getElementById("s7viewer").style.display = "block"
  }
  if (count >= 3) {
    const elementImage = document.querySelector("#imageoverlay")
    elementImage?.classList.add("zoom-activated")
  }
}

export const closeZoomImage = () => {
  pauseAllVideo()
  const s7viewerSpinThreeSixty = document.querySelector(
    "#s7viewerSpinThreeSixty"
  )
  const s7viewerZoomImg = document.querySelector("#s7viewer")
  if (s7viewerZoomImg) {
    document.getElementById("s7viewer").innerHTML = ""
  }

  if (s7viewerSpinThreeSixty) {
    document.getElementById("s7viewerSpinThreeSixty").innerHTML = ""
    document.getElementById("s7viewerSpinThreeSixty").style.display = "none"
  }
  const zoomVideo = document.querySelector(".zoom-video")
  if (zoomVideo) {
    document.getElementById("zoomVideo").innerHTML = ""
    document.getElementById("zoomVideo").style.display = "none"
  }
  document.body.classList.remove("zoom-image-scroll")
  const element = document.querySelector(".product-detail-page")
  element?.classList.remove("zoom-image-product-section")
  element?.classList.remove("three-sixty-image-gallery")
  document.getElementById("imageoverlay").style.display = "none"
}

export const zoomVideoImage = () => {
  const zoomVideo = document.querySelector(".zoom-video")
  if (zoomVideo) {
    document.getElementById("zoomVideo").style.display = "block"
  }
  document.getElementById("s7viewer").style.display = "none"
  document.getElementById("s7viewerSpinThreeSixty").style.display = "none"
  document.getElementById("s7viewerSpinThreeSixty").innerHTML = ""
  const element = document.querySelector(".product-detail-page")
  element?.classList.remove("three-sixty-image-gallery")
}

export const getSlickSettings = () => {
  const { desktopSliderImages } = PDP_SLIDER_SIZES
  return {
    dots: false,
    slidesToShow: desktopSliderImages,
    slidesToScroll: 3,
    swipeToSlide: true,
    swipe: true,
    arrows: true,
    infinite: false,
    centerMode: false,
    centerPadding: "0px",
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4.8,
          focusOnSelect: false,
          centerPadding: "10px",
        },
      },
    ],
  }
}

export const spin360Open = (assetID = "", zoomSpinCB = () => {}) => {
  pauseAllVideo()
  const zoomViewer = new window.s7viewers.SpinViewer({
    handlers: {
      trackEvent: function (objID, compClass, instName, timeStamp, eventInfo) {
        zoomSpinCB(eventInfo)
      },
    },
  })
  zoomViewer?.setContainerId("s7viewerSpinThreeSixty")
  zoomViewer?.setParam("serverurl", SCENE7_SERVER_IMAGE)
  zoomViewer?.setAsset(`PAWEB/${assetID}`)
  zoomViewer?.init()
  const zoomVideo = document.querySelector(".zoom-video")
  if (zoomVideo) {
    document.getElementById("zoomVideo").style.display = "none"
  }
}
export const spin360PdpGallery = (assetID = "", zoomSpinCBPdp = () => {}) => {
  pauseAllVideo()
  if (typeof window !== "undefined" && window?.s7viewers) {
    const zoomViewer = new window.s7viewers.SpinViewer({
      handlers: {
        trackEvent: function (
          objID,
          compClass,
          instName,
          timeStamp,
          eventInfo
        ) {
          zoomSpinCBPdp(eventInfo)
        },
      },
    })
    zoomViewer?.setContainerId("s7viewerGallery")
    zoomViewer?.setParam("serverurl", SCENE7_SERVER_IMAGE)
    zoomViewer?.setAsset(`PAWEB/${assetID}`)
    zoomViewer?.init()
  }
}

export const pauseAllVideo = () => {
  const iframes = document.querySelectorAll("iframe")
  if (iframes) {
    Array.prototype.forEach.call(iframes, iframe => {
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "stopVideo" }),
        "*"
      )
    })
  }
}
